<template>
  <PasswordRecover />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PasswordRecover from "@/components/Modules/Authentication/PasswordRecover/index.vue";

export default defineComponent({
  name: "PasswordRecoverPage",
  components: {
    PasswordRecover,
  },
});
</script>
